import { render, staticRenderFns } from "./WidgetAddOnSizeRecommendation.vue?vue&type=template&id=32aaf4d1"
import script from "./WidgetAddOnSizeRecommendation.vue?vue&type=script&lang=js"
export * from "./WidgetAddOnSizeRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports